<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-col cols="12" class="pa-0 px-0">
            <assetproduct-chart
                :url="'assetproductdistribution'"
                :title="'Distribuzione Prodotti'"
            ></assetproduct-chart>
        </v-col>
    </v-row>
</template>

<script>
    import AssetproductChart from '@/components/modules/assets/AssetproductChart'

    export default {
        name: 'asset-statistics',
        components: {
			AssetproductChart
        },

        props: {
        },

        data() {
            return {

            }
        },

        created() {
            this.$store.commit('endProgress')
        },
        
    }
</script>

<style>

</style>
